// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"c01a2be5","898":"0e9f8dda","921":"5577717b","971":"1868653b"}[chunkId] + ".chunk.js";
};